var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostPurchaseScreen',{attrs:{"title":"ORDER PUT ON HOLD","body":"You can always come back later and login to continue placing your order!"}})}
var staticRenderFns = []

export { render, staticRenderFns }